/*
 * Copyright (c) Nexign, JSC, 2019-2021.
 */

/**
 *
 *
 * @author Yakov Gushchin
 * @author Anton Panasenko
 * @author Aleksandr Perkhunov
 * @version 1.13.0
 * @since 1.0.1
 */

import styled from 'styled-components';

import { colors, fonts } from '../../../../../theme';
import { IAttrStyled } from '../../../../../types/globalTypes';

export const ChartContainerStyled = styled.div.attrs({
    className: 'chart-pie',
})`
    display: flex;
    flex-direction: column;
    align-items: center;

    & .chart__title {
        ${fonts.textHeader3}
        margin-bottom: 0;
    }

    & .chart__title_small {
        ${fonts.textMainBold}
    }

    & .collapse {
        margin-bottom: 12px;
    }
`;

export const ChartHolderStyled = styled.div.attrs({
    className: 'chart-pie__diagram',
})`
    height: 226px;
    z-index: 0;
`;

/*
* -------------------------------------------
*                LEGEND
* -------------------------------------------
*/

export const ChartLegendStyled = styled.div.attrs(({ className }: IAttrStyled) => ({
    className: `chart-pie__legend ${className || ''}`,
}))<IAttrStyled>`
    display: flex;
    flex-direction: column;
    width: 100%;
    margin-top: 32px;

    &.legend-with-children {
        .MuiCollapse-container {
            margin-left: 12px;
        }

        .legend:not(.legend_has-children) {
            .legend__price {
                margin-right: 32px;
            }
        }

        .collapse__panel-body {
            .legend:first-child {
                margin-top: 8px;
            }
            .legend:not(:last-child) {
                margin-bottom: 8px;
            }
        }
    }
`;

export const ChartLegendItemStyled = styled.div.attrs((props: IAttrStyled) => ({
    className: `legend ${props.className}`,
}))<IAttrStyled>`
    display: flex;
    align-items: center;
    margin-bottom: 12px;

    &:last-child {
        margin-bottom: 0;
    }

    &.disable {
        color: ${colors.textColorOpacity};
    }
`;

export const ChartLegendItemColorStyled = styled.div.attrs({
    className: 'legend__color',
})`
    width: 8px;
    height: 8px;
    margin-right: 8px;
    border-radius: 100%;
`;

export const ChartLegendItemNameStyled = styled.div.attrs({
    className: 'legend__name',
})`
    display: flex;
    align-items: center;
    width: 221px;
`;

export const ChartLegendItemPriceStyled = styled.div.attrs({
    className: 'legend__price',
})`
    flex-grow: 1;
    text-align: right;
`;

/*
* -------------------------------------------
*                TOOLTIP
* -------------------------------------------
*/

export const ChartTooltipStyled = styled.div`
    position: fixed;
    display: flex;
    z-index: 10;
    align-items: center;
    padding: 12px;
    width: 360px;
    min-height: 56px;
    box-sizing: border-box;
    box-shadow: 0 0 12px 0 rgba(51, 51, 51, 0.2);
    background: ${colors.pageDashboardChartTooltipBgColor};
    transition: opacity 0.3s ease-in-out;

    &:after {
        position: absolute;
        bottom: -8px;
        width: 0;
        height: 0;
        border-left: 6.5px solid transparent;
        border-right: 6.5px solid transparent;
        border-top: 8px solid ${colors.pageDashboardChartTooltipBgColor};
        content: ' ';
    }

    & .tooltip__name {
        max-width: 180px;
    }

    & .tooltip__value {
        flex-grow: 1;
        margin-left: 6px;
        text-align: right;
    }

    & .tooltip__percent {
        margin-left: 8px;
    }
`;

export const ChartTooltipDotStyled = styled.div<{ color: string }>`
    width: 8px;
    height: 8px;
    margin-right: 8px;
    border-radius: 100%;
    background: ${props => props.color};
`;

export const ChartTooltipPercentStyled = styled.span.attrs({
    className: 'tooltip__percent',
})`
    color: ${colors.pageDashboardChartTextColorSecondary};
`;
